/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save(props) {
	const { attributes } = props;

	return (
		<div { ...useBlockProps.save({className: `wpopus-accordion ${attributes.options.iconPlacement}`}) }>
			<div 
				className='wpopus-accordion-wrapper'
				style={{
					"--wpopus-accordion-item-gap": `${attributes.options.gap}px`
				}}
			>
				<InnerBlocks.Content />
			</div>
		</div>
	);
}
